export default __webpack_public_path__ + "static/media/discover-something-onboarding-carousel-web.b6fb7027.png";